import { connect } from 'react-redux'
import { pageToggleOverlay } from 'redux/actions'
import DealCompare from 'pages/mwdealcompare/Main'

const mapStateToProps = state => ({
  isLogged: state.user.isLogged,
  isLimitedAccess: state.user.isLimitedAccess
})

const mapDispatchToProps = dispatch => ({
  pageToggleOverlay: (component) => dispatch(pageToggleOverlay(component))
})

export default connect(mapStateToProps, mapDispatchToProps)(DealCompare)
